import { ValidationError } from 'yup';
export function yupErrorParse(error) {
    // returns array of errors for validator
    return error.errors.map(e => e.split(' ')[0]);
}
export function yupErrorMessageParse(error) {
    if (error instanceof ValidationError) {
        return error.inner;
    }
    return error;
}
//# sourceMappingURL=yupErrorParse.js.map